import type { SetStateAction } from 'react';
import { createContext } from 'react';
import { type UseQueryResult } from 'react-query';
import type { ITax, TaxCheckEnum } from 'types/taxes.types';

const CurrentTaxContext = createContext<
  | (UseQueryResult<ITax, unknown> & {
      currentCheck: TaxCheckEnum;
      setCurrentCheck: SetStateAction<string>;
    })
  | any
>({});

export default CurrentTaxContext;
